import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';

import { PortalFlightItineraryGroupNode } from '@app/services/api/api.types';
import { PopupsService } from '@voyagu/portal-design-system';

@Component({
  selector: 'extra-leg',
  templateUrl: './extra-leg.component.html',
  styleUrls: ['./extra-leg.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExtraLegComponent {
  @Input() itinerary: PortalFlightItineraryGroupNode;

  constructor(private popupsService: PopupsService) {}

  show(template: TemplateRef<unknown>) {
    this.popupsService.showModal(template);
  }

  hide() {
    this.popupsService.hideLast();
  }
}
